/**
 * Initializes the location selection tool in WPD.
 */
function init(wpd, wpdDocument) {
	wpd.LocationSelectionTool = class {
		constructor(resolve, keydownHandler) {
			this.resolve = resolve;
			this.keydownHandler = keydownHandler;
			this.canvas = wpd.graphicsWidget.$hoverCanvas;
		}

		#addEventListeners() {
			this.#removeEventListeners();
			this.canvas.addEventListener("click", this.#onClick, true);
			wpdDocument.addEventListener("keydown", this.#onKeyDown, true);
		}

		#removeEventListeners() {
			this.canvas.removeEventListener("click", this.#onClick, true);
			wpdDocument.removeEventListener("keydown", this.#onKeyDown, true);
		}

		#getLocationFromClick(event) {
			// get canvas position
			const canvasRect = this.canvas.getBoundingClientRect();

			// calculate click position relative to canvas
			const xCss = event.clientX - canvasRect.left;
			const yCss = event.clientY - canvasRect.top;

			// convert css to canvas px
			let scaleX = 1;
			let scaleY = 1;
			if (this.canvas instanceof HTMLCanvasElement) {
				scaleX = this.canvas.width / canvasRect.width;
				scaleY = this.canvas.height / canvasRect.height;
			}

			// convert to image coordinates
			const imageCoords = wpd.graphicsWidget.imagePx(
				xCss * scaleX,
				yCss * scaleY,
			);

			return imageCoords;
		}

		// fat-arrow function allows "this" to be the instance of this class
		// instead of having it determined by the caller
		#onKeyDown = (event) => {
			this?.keydownHandler(event);
		};

		#onClick = (event) => {
			// get the location from the click
			const location = this.#getLocationFromClick(event);

			// resolve immediately with the location
			this.resolve({
				location: location,
			});

			this.detach();
		};

		attach() {
			this.#addEventListeners();
			this.canvas.style.zIndex = 6;
		}

		detach() {
			this.#removeEventListeners();
			this.canvas.style.zIndex = 4;
		}
	};
}

export { init };
